import { Avatar, Button, Dropdown } from "antd";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../network/authContext";

function getStoredUser() {
  try {
    return JSON.parse(sessionStorage.getItem("adminUser")) || {};
  } catch (_) {
    return {};
  }
}

function getInitials(user) {
  const names = [user.firstName, user.lastName].filter(Boolean);
  if (names.length) return names.map((name) => name.charAt(0)).join("").slice(0, 2).toUpperCase();

  const fallback = user.username || user.email || "Admin System";
  return fallback.split(/[\s@._-]+/).filter(Boolean).map((part) => part.charAt(0)).join("").slice(0, 2).toUpperCase() || "AS";
}

export default function HeaderUser() {
  const history = useHistory();
  const { logout } = useAuth();
  const initials = getInitials(getStoredUser());
  const menu = (
    <div className="hp-user-dropdown hp-border-radius hp-bg-black-0 hp-bg-dark-100 hp-border-color-dark-80 hp-p-12 hp-mt-8">
      <Button type="text" danger block className="hp-text-left" onClick={() => {
        logout();
        history.replace("/");
      }}>
        Abmelden
      </Button>
    </div>
  );

  return (
    <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
      <Avatar size={40} className="hp-cursor-pointer hp-bg-primary-1 oekfb-admin-header__avatar" aria-label={`Benutzermenü ${initials}`}>
        {initials}
      </Avatar>
    </Dropdown>
  );
}
